module.exports = __webpack_public_path__ + "static/media/boris.82e83088.png";